const API_URL = import.meta.env.VITE_API_URL;

async function request(path, { method = 'GET', body, actorEmployeeCode } = {}) {
  const url = new URL(`${API_URL}${path}`);
  if (actorEmployeeCode) url.searchParams.set('actorEmployeeCode', actorEmployeeCode);
  const payload = body ? { ...body, actorEmployeeCode } : undefined;
  const res = await fetch(url.toString(), {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: method === 'GET' ? undefined : JSON.stringify(payload || { actorEmployeeCode }),
  });
  const json = await res.json().catch(() => null);
  if (!res.ok || json?.resType === 'error') {
    const err = new Error(json?.resMessage || `เกิดข้อผิดพลาด (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return json?.data || json;
}

export function listPageGrants() {
  return request('/pageAccess/grants');
}

export function createPageGrant(actorEmployeeCode, body) {
  return request('/pageAccess/grants', { method: 'POST', actorEmployeeCode, body });
}

export function updatePageGrant(actorEmployeeCode, grantId, body) {
  return request(`/pageAccess/grants/${encodeURIComponent(grantId)}`, {
    method: 'PUT',
    actorEmployeeCode,
    body,
  });
}

export function deletePageGrant(actorEmployeeCode, grantId) {
  return request(`/pageAccess/grants/${encodeURIComponent(grantId)}`, {
    method: 'DELETE',
    actorEmployeeCode,
  });
}
